import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { memo } from 'react';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
import { Modal } from '..';
import ModalHeader from '../modal-header';
import { ModalContent } from '../modal-content';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MobileModal = /*#__PURE__*/memo(function (_ref) {
  var show = _ref.show,
      close = _ref.close,
      children = _ref.children,
      _ref$closebutton = _ref.closebutton,
      closebutton = _ref$closebutton === void 0 ? true : _ref$closebutton,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      haltGestures = _ref.haltGestures;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  return /*#__PURE__*/_jsx(Modal, {
    haltGestures: haltGestures,
    layout: "modal",
    isOpen: show,
    onClose: close,
    variant: variant,
    children: /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [closebutton && isDesktop ? /*#__PURE__*/_jsx(ModalHeader, {
        variant: "desktop-with-title-close-button",
        onClose: close
      }) : /*#__PURE__*/_jsx(ModalHeader, {
        variant: "mobile-without-title"
      }), /*#__PURE__*/_jsx(ModalContent, {
        children: children
      })]
    })
  });
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "modalmobile___StyledDiv",
  componentId: "sc-be83c3-0"
})({
  "@media (min-width: 768px)": {
    "maxHeight": "90vh",
    "overflowY": "auto"
  }
});